import { render } from "./Handlers.vue?vue&type=template&id=4e2eb95c&scoped=true"
import script from "./Handlers.vue?vue&type=script&lang=js"
export * from "./Handlers.vue?vue&type=script&lang=js"

import "./Handlers.vue?vue&type=style&index=0&id=4e2eb95c&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2eb95c"]])

export default __exports__